var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 13.8333H4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 8.5H4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 19.1667H4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 24.5H4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-icon",
    stroke: "currentColor",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00014 13H17.1359C18.1487 13 18.6551 13 19.0582 12.8112C19.4134 12.6448 19.7118 12.3777 19.9163 12.0432C20.1485 11.6633 20.2044 11.16 20.3163 10.1534L20.9013 4.88835C20.9355 4.58088 20.9525 4.42715 20.9031 4.30816C20.8597 4.20366 20.7821 4.11697 20.683 4.06228C20.5702 4 20.4155 4 20.1062 4H3.50014M1 1H2.24844C2.51306 1 2.64537 1 2.74889 1.05032C2.84002 1.09463 2.91554 1.16557 2.96544 1.25376C3.02212 1.35394 3.03037 1.48599 3.04688 1.7501L3.95312 16.2499C3.96963 16.514 3.97788 16.6461 4.03456 16.7462C4.08446 16.8344 4.15998 16.9054 4.25111 16.9497C4.35463 17 4.48694 17 4.75156 17H18M6.5 20.5H6.51M15.5 20.5H15.51M7 20.5C7 20.7761 6.77614 21 6.5 21C6.22386 21 6 20.7761 6 20.5C6 20.2239 6.22386 20 6.5 20C6.77614 20 7 20.2239 7 20.5ZM16 20.5C16 20.7761 15.7761 21 15.5 21C15.2239 21 15 20.7761 15 20.5C15 20.2239 15.2239 20 15.5 20C15.7761 20 16 20.2239 16 20.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.586l-7.071-7.071-1.414 1.414 7.071 7.071-7.071 7.071 1.414 1.414 7.071-7.071 7.071 7.071 1.414-1.414-7.071-7.071 7.071-7.071-1.414-1.414-7.071 7.071z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "basket",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00014 13H17.1359C18.1487 13 18.6551 13 19.0582 12.8112C19.4134 12.6448 19.7118 12.3777 19.9163 12.0432C20.1485 11.6633 20.2044 11.16 20.3163 10.1534L20.9013 4.88835C20.9355 4.58088 20.9525 4.42715 20.9031 4.30816C20.8597 4.20366 20.7821 4.11697 20.683 4.06228C20.5702 4 20.4155 4 20.1062 4H3.50014M1 1H2.24844C2.51306 1 2.64537 1 2.74889 1.05032C2.84002 1.09463 2.91554 1.16557 2.96544 1.25376C3.02212 1.35394 3.03037 1.48599 3.04688 1.7501L3.95312 16.2499C3.96963 16.514 3.97788 16.6461 4.03456 16.7462C4.08446 16.8344 4.15998 16.9054 4.25111 16.9497C4.35463 17 4.48694 17 4.75156 17H18M6.5 20.5H6.51M15.5 20.5H15.51M7 20.5C7 20.7761 6.77614 21 6.5 21C6.22386 21 6 20.7761 6 20.5C6 20.2239 6.22386 20 6.5 20C6.77614 20 7 20.2239 7 20.5ZM16 20.5C16 20.7761 15.7761 21 15.5 21C15.2239 21 15 20.7761 15 20.5C15 20.2239 15.2239 20 15.5 20C15.7761 20 16 20.2239 16 20.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04894 1.42705C6.3483 0.505742 7.6517 0.505741 7.95106 1.42705L8.79611 4.02786C8.92999 4.43989 9.31394 4.71885 9.74717 4.71885H12.4818C13.4505 4.71885 13.8533 5.95846 13.0696 6.52786L10.8572 8.13525C10.5067 8.3899 10.3601 8.84127 10.494 9.25329L11.339 11.8541C11.6384 12.7754 10.5839 13.5415 9.80017 12.9721L7.58779 11.3647C7.2373 11.1101 6.7627 11.1101 6.41222 11.3647L4.19983 12.9721C3.41612 13.5415 2.36164 12.7754 2.66099 11.8541L3.50604 9.25329C3.63992 8.84127 3.49326 8.3899 3.14277 8.13525L0.930391 6.52787C0.146677 5.95846 0.549452 4.71885 1.51818 4.71885H4.25283C4.68606 4.71885 5.07001 4.43989 5.20389 4.02786L6.04894 1.42705Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "heart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    stroke: "#f8f8f8",
    style: {
      stroke: "var(--color1, #f8f8f8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9091,
    d: "M27.787 6.147c-0.681-0.681-1.49-1.222-2.38-1.591s-1.844-0.559-2.807-0.559-1.917 0.19-2.807 0.559c-0.89 0.369-1.698 0.909-2.38 1.591l-1.413 1.413-1.413-1.413c-1.376-1.376-3.241-2.148-5.187-2.148s-3.811 0.773-5.187 2.148c-1.376 1.376-2.148 3.241-2.148 5.187s0.773 3.811 2.148 5.187l11.787 11.787 11.787-11.787c0.681-0.681 1.222-1.49 1.591-2.38s0.559-1.844 0.559-2.807c0-0.963-0.19-1.917-0.559-2.807s-0.909-1.699-1.591-2.38v0z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.565 28.436l-5.565-5.52c2.16-2.693 3.206-6.112 2.923-9.553s-1.874-6.643-4.445-8.947-5.928-3.536-9.379-3.441c-3.451 0.094-6.735 1.508-9.177 3.949s-3.855 5.725-3.949 9.177c-0.094 3.451 1.137 6.808 3.441 9.379s5.506 4.162 8.947 4.445c3.441 0.283 6.86-0.763 9.553-2.923l5.52 5.52c0.139 0.141 0.305 0.252 0.488 0.328s0.379 0.115 0.577 0.115c0.198 0 0.394-0.039 0.577-0.115s0.349-0.188 0.488-0.328c0.27-0.28 0.421-0.654 0.421-1.043s-0.151-0.763-0.421-1.042zM14.5 25.001c-2.077 0-4.107-0.616-5.833-1.77s-3.073-2.794-3.867-4.712c-0.795-1.919-1.003-4.030-0.598-6.067s1.405-3.908 2.874-5.376c1.468-1.468 3.339-2.468 5.376-2.874s4.148-0.197 6.067 0.598c1.919 0.795 3.559 2.141 4.712 3.867s1.77 3.757 1.77 5.833c0 2.785-1.106 5.455-3.075 7.425s-4.64 3.075-7.425 3.075z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "cook-hat",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9bb537",
    style: {
      fill: "var(--color1, #9bb537)"
    },
    d: "M7.325 12.723h23.133v17.735h-23.133v-17.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9bb537",
    style: {
      fill: "var(--color1, #9bb537)"
    },
    d: "M16.578 11.373c0 4.578-3.711 8.289-8.289 8.289s-8.289-3.711-8.289-8.289c0-4.578 3.711-8.289 8.289-8.289s8.289 3.711 8.289 8.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9bb537",
    style: {
      fill: "var(--color1, #9bb537)"
    },
    d: "M26.988 8.289c0 4.578-3.711 8.289-8.289 8.289s-8.289-3.711-8.289-8.289c0-4.578 3.711-8.289 8.289-8.289s8.289 3.711 8.289 8.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9bb537",
    style: {
      fill: "var(--color1, #9bb537)"
    },
    d: "M37.398 11.373c0 4.578-3.711 8.289-8.289 8.289s-8.289-3.711-8.289-8.289c0-4.578 3.711-8.289 8.289-8.289s8.289 3.711 8.289 8.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    style: {
      fill: "var(--color2, #f8f8f8)"
    },
    d: "M7.325 29.301h23.133v2.036c0 0.366-0.324 0.663-0.723 0.663h-21.687c-0.399 0-0.723-0.297-0.723-0.663v-2.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    style: {
      fill: "var(--color2, #f8f8f8)"
    },
    d: "M14.265 10.36c0-0.611 0.432-1.107 0.964-1.107s0.964 0.495 0.964 1.107v5.112c0 0.611-0.432 1.107-0.964 1.107s-0.964-0.495-0.964-1.107v-5.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    style: {
      fill: "var(--color2, #f8f8f8)"
    },
    d: "M17.349 10.36c0-0.611 0.604-1.107 1.349-1.107s1.349 0.495 1.349 1.107v5.112c0 0.611-0.604 1.107-1.349 1.107s-1.349-0.495-1.349-1.107v-5.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    style: {
      fill: "var(--color2, #f8f8f8)"
    },
    d: "M21.205 10.36c0-0.611 0.432-1.107 0.964-1.107s0.964 0.495 0.964 1.107v5.112c0 0.611-0.432 1.107-0.964 1.107s-0.964-0.495-0.964-1.107v-5.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    style: {
      fill: "var(--color3, #050505)"
    },
    d: "M28.184 3.131c0.289-0.030 0.581-0.045 0.878-0.045 3.714 0 6.861 2.413 7.938 5.746-0.289 0.030-0.581 0.045-0.878 0.045-3.714 0-6.861-2.413-7.938-5.746z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "spinner",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.627-5.373-12-12-12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0-5.514 4.486-10 10-10v1.5C7.477 3.5 3.5 7.477 3.5 12H2zm19.721-1.638c-.273-.263-.673-.329-.998-.164l-2.104.701c-.469.156-.81.57-.901 1.065l-.729 4.978c-.058.394.082.796.367 1.078.128.139.288.243.468.301l2.225.593c.151.04.303.06.454.06.316 0 .625-.118.864-.34l2.239-1.58c.44-.312.548-.916.235-1.356l-1.207-1.692a1.004 1.004 0 0 1-.166-1.056l.518-.938a.994.994 0 0 0-.166-1.215l-1.833-1.679zM17.068 5.302c.127-.14.303-.224.492-.224h4.5c.276 0 .5.224.5.5v4.5a.501.501 0 0 1-.224.416l-1.679 1.208c-.44.314-1.044.206-1.355-.234l-.9-1.26a.998.998 0 0 0-1.286-.263l-.897.51a.993.993 0 0 1-1.213-.167l-.938-.519c-.301-.166-.71-.03-.924.271l-1.68 2.396c-.224.318-.146.764.177 1.015l2.224 1.58c.464.329 1.068.222 1.389-.243l.703-.999a1.006 1.006 0 0 0-.163-1.287l-1.261-.898a.99.99 0 0 1-.263-1.285l.509-.897z",
    fill: "#1c1c1c"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-up",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.472 28.449v2.992c0 0.194-0.157 0.351-0.351 0.351s-0.351-0.157-0.351-0.351v-2.992c0-0.194 0.157-0.351 0.351-0.351s0.351 0.157 0.351 0.351z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.284 11.464c0 0.212-0.080 0.424-0.242 0.585l-3.367 3.367c-0.323 0.322-0.848 0.322-1.17 0l-3.318-3.318v9.444c0 0.194-0.157 0.351-0.351 0.351s-0.351-0.157-0.351-0.351v-10.292c0-0.142 0.085-0.27 0.217-0.325s0.282-0.024 0.383 0.076l3.918 3.918c0.049 0.049 0.128 0.049 0.177-0l3.367-3.367c0.049-0.049 0.049-0.128 0-0.177l-10.461-10.46c-0.029-0.029-0.067-0.035-0.093-0.034-0.053-0.001-0.090 0.004-0.12 0.034l-10.461 10.46c-0.063 0.064-0.065 0.113 0 0.177l3.367 3.367c0.049 0.049 0.128 0.049 0.177 0l3.918-3.918c0.1-0.1 0.252-0.131 0.383-0.076s0.217 0.183 0.217 0.325v14.1c0 0.194-0.157 0.351-0.351 0.351s-0.351-0.157-0.351-0.351v-13.252l-3.318 3.318c-0.323 0.322-0.848 0.322-1.17 0l-3.367-3.367c-0.313-0.313-0.313-0.858 0-1.17l10.46-10.46c0.163-0.163 0.382-0.248 0.616-0.239 0.208-0.009 0.427 0.076 0.59 0.239l10.461 10.46c0.162 0.161 0.243 0.373 0.243 0.585z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.187 24.464v2.914c0 0.194-0.157 0.351-0.351 0.351s-0.351-0.157-0.351-0.351v-2.914c0-0.194 0.157-0.351 0.351-0.351s0.351 0.157 0.351 0.351z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.329 17.203v12.022c0 0.194-0.157 0.351-0.351 0.351s-0.351-0.157-0.351-0.351v-12.022c0-0.194 0.157-0.351 0.351-0.351s0.351 0.157 0.351 0.351z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "rate-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.357 1.219c0.273-0.517 1.014-0.517 1.286 0l4.525 8.576c0.105 0.199 0.297 0.339 0.519 0.377l9.555 1.653c0.576 0.1 0.805 0.804 0.398 1.223l-6.758 6.954c-0.157 0.162-0.23 0.387-0.198 0.61l1.38 9.598c0.083 0.579-0.516 1.014-1.041 0.756l-8.702-4.279c-0.202-0.099-0.439-0.099-0.642 0l-8.702 4.279c-0.525 0.258-1.124-0.177-1.041-0.756l1.38-9.598c0.032-0.223-0.041-0.449-0.198-0.61l-6.758-6.954c-0.408-0.419-0.179-1.124 0.398-1.224l9.555-1.653c0.222-0.038 0.414-0.178 0.519-0.377l4.525-8.576z"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shopping-cart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M9 22c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M20 22c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 1.8,
    strokeWidth: 1.8,
    d: "M1 1h4l2.68 13.39c0.091 0.46 0.342 0.874 0.708 1.168s0.823 0.451 1.292 0.442h9.72c0.469 0.009 0.927-0.147 1.293-0.442s0.616-0.708 0.708-1.168l1.6-8.39h-17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.8c7fcfc3aa0d5f7f9c67039932610633.svg";
export { ForwardRef as ReactComponent };